"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _mergeProperties = _interopRequireDefault(require("./mergeProperties"));

var _default = function _default(_ref) {
  var properties = _ref.properties,
      objectType = _ref.objectType,
      requestSuccessActionType = _ref.requestSuccessActionType,
      requestSuccessDataSelector = _ref.requestSuccessDataSelector;
  return (0, _defineProperty2.default)({}, requestSuccessActionType, function (state, action) {
    var data = requestSuccessDataSelector ? requestSuccessDataSelector(action.payload) : action.payload[objectType];
    return (0, _mergeProperties.default)(properties, state, data);
  });
};

exports.default = _default;
module.exports = exports.default;